import * as Sentry from '@sentry/react';

export const sentryError = (error) => {
  if (process.env.NODE_ENV === 'development') {
    return console.error('ERROR', error);
  } else {
    Sentry.captureException(error);
  }
};
